<template>
  <div class="kk-tree">
    <div v-for="item in data" :key="item.id">
      <tree-item
        v-if="!item.hide"
        :id="item.id"
        :item-id="item.itemId"
        :depth="depth"
        :is-active="isActive(item.id)"
        :editable="editable(item.id)"
      />
      <div v-if="item.expanded && !item.hide && item.children.length > 0">
        <tree :data="item.children" :depth="depth + 1" />
      </div>
    </div>
  </div>
</template>

<script>
import TreeItem from "./TreeItem.vue";
export default {
  name: "Tree",
  components: { TreeItem },
  props: ["data", "depth"],
  methods: {
    isActive(id) {
      return this.$store.state.grids.activeGrid.id === id && !this.$store.state.grids.editMode;
    },
    editable(id) {
      return (
        this.$store.state.grids.activeGrid.editMode &&
        this.$store.state.grids.activeGrid.id === id &&
        this.$store.getters["grids/isEditAllowed"](id)
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/variables";
</style>
